// import external modules
import React from "react";
import Navbar from "../components/navbar/navbar";
// import Sidebar from '../components/sidebar/sidebar';
import { useDispatch, useSelector } from "react-redux";
// import { setSidebarStatus } from '../redux/actions/sidebar/sidebarAction';
// import Success from '../components/SuccessFul';
import Footer from "../components/footer/footer";
import NewNavBar from "../components/navbar/newNavBar";
const AdminLayout = ({ children, props, ...rest }) => {
  const dispatch = useDispatch();
  // const { message } = useSelector((state) => ({
  //   message: state.message.message,
  // }));
  // console.log('value of message', message);
  return (
    <div>
      <main className="admin-panel">
        <div className="navbar-block">
          <NewNavBar />
        </div>
        <div
          className="admin-layout-body"
          onClick={() => {
            // console.log('i am called');
            // dispatch(setSidebarStatus(false));
          }}
        >
          {/* {message.type == 'success' ? <Success title={message.message} /> : ''} */}
          {children}
        </div>
        <div className>
          <Footer></Footer>
        </div>
        {/* <Footer /> */}
      </main>
    </div>
  );
};

export default AdminLayout;
